export const TEMPLATE_RULES_DATA = {
  id: "",
  templateId: 0,
  templateName: "",
  group: "",
  ruleExpressions: [],
  outputFormat: "",
  categoryId: 0,
  groupId: 0,
};

export enum EntityTypes {
  ALL = "All",
  CASE = "Case",
  SUBCASE = "SubCase",
  CREDITOR = "Creditor",
  DEBTOR = "Debtor",
}

export const ENTITY_GROUPS_OPTIONS = [
  {
    value: EntityTypes.ALL,
    label: "US.COLLECTION.COMMON:COMMON.ALL",
  },
  {
    value: EntityTypes.SUBCASE,
    label: "US.COLLECTION.COMMON:COMMON.SUBCASE",
  },
  {
    value: EntityTypes.CASE,
    label: "US.COLLECTION.COMMON:COMMON.CASE",
  },
  {
    value: EntityTypes.DEBTOR,
    label: "US.COLLECTION.COMMON:COMMON.DEBTOR",
  },
  {
    value: EntityTypes.CREDITOR,
    label: "US.COLLECTION.COMMON:COMMON.CREDITOR",
  },
];
